import { axios } from "~/plugins/request"

export const state = () => {
	return {}
}
export const mutations = {}

export const actions = {
	list({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`/workPlanWeekNew/list`, params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  getCreateInfo({ commit }, data) {
		return new Promise((resolve, reject) => {
			axios({
        method: 'get',
        url: '/workPlanWeekNew/getCreateInfo',
        params: data
      })
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  findOrgTreeByCurrentUser({ commit }, data) {
		return new Promise((resolve, reject) => {
			axios({
        method: 'get',
        url: 'workPlanWeekNew/findOrgTreeByCurrentUser'
      })
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  getWeekList({ commit }) {
		return new Promise((resolve, reject) => {
			axios.get(`/workPlanWeekNew/getWeekList`)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  generateWeekReport({ commit }, data) {
		return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        url: '/workPlanWeekNew/generateWeekReport',
        params: data
      })
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  sgetWeekPlanOrReportList({ commit }, data) {
		return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        url: '/workPlanWeekNew/getWeekPlanOrReportList',
        params: data
      })
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  getSearchTitle({ commit }) {
		return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        url: '/workPlanWeekNew/getSearchTitle'
      })
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  getNoFinishList({ commit }, data) {
		return new Promise((resolve, reject) => {
      axios.post('/workPlanWeekNew/getNoFinishList', data)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  createNewPlan({ commit }, data) {
		return new Promise((resolve, reject) => {
			axios({
        method: 'get',
        url: '/workPlanWeekNew/createNewPlan',
        params: data
      })
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  save({ commit }, data) {
		return new Promise((resolve, reject) => {
			axios.post(`/workPlanWeekNew/saveWeekInfo`, data)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  saveWeekQuestion({ commit }, data) {
		return new Promise((resolve, reject) => {
			axios.post(`/workPlanWeekNew/saveWeekQuestion`, data)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  findById({ commit }, data) {
		return new Promise((resolve, reject) => {
			axios({
        method: 'get',
        url: '/workPlanWeekNew/findById',
        params: data
      })
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  delete({ commit }, data) {
		return new Promise((resolve, reject) => {
			axios({
        method: 'get',
        url: '/workPlanWeekNew/delete',
        params: data
      })
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
}
